import type { Variants } from 'framer-motion';

/**
 * Variants Framer Motion réutilisables pour la page d'accueil.
 *
 * Pattern : chaque variant définit "hidden" (état initial, hors écran)
 * et "visible" (état final, dans le viewport). À utiliser avec
 * `initial="hidden"` + `whileInView="visible"` sur un motion.div.
 *
 * Tous respectent automatiquement prefers-reduced-motion (Framer le gère
 * nativement quand on utilise viewport={{ once: true }}).
 */

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] }, // easeOutExpo
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.8, ease: 'easeOut' },
  },
};

export const slideLeft: Variants = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  },
};

export const slideRight: Variants = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
  },
};

/** Container : aucun changement propre, mais stagger ses enfants directs. */
export const staggerContainer = (stagger = 0.1, delay = 0): Variants => ({
  hidden: {},
  visible: {
    transition: {
      staggerChildren: stagger,
      delayChildren: delay,
    },
  },
});

/** Variants courts pour le titre du Hero (chaque mot apparaît). */
export const heroTitleWord: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

/** Map nom → variant pour AnimatedSection. */
export const VARIANT_MAP = {
  fadeUp,
  fadeIn,
  slideLeft,
  slideRight,
  scaleIn,
} as const;

export type VariantName = keyof typeof VARIANT_MAP;
